module.exports = __webpack_public_path__ + "img/close.bc2765c2.svg";